module.exports = __webpack_public_path__ + "img/mouse.f67f781c.png";